<template>
<section class="device-wrapper">
  <section class="device-list-wrapper">
    <device-list />
  </section>
  <section class="device-factor-wrapper">
    <device-factor />

    <device-status />
  </section>
</section>
</template>

<script>
import DeviceFactor from './DeviceFactor'
import DeviceStatus from './DeviceStatus'
import DeviceList from './DeviceList'

export default {
  name: 'SystemSettingsDevice',
  routeInfo: {
    label: '设备管理',
    icon: 'fa fa-laptop',
    curdInfo: {
      api: 'Device',
      id: 'id',
      name: 'name',
      editName: '设备'
    }
  },
  components: {
    DeviceList,
    DeviceFactor,
    DeviceStatus
  }
}
</script>

<style lang="scss" scoped>
.device-wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;

  > {
    .device-list-wrapper,
    .device-factor-wrapper {
      width: 100%;
      height: 50%;
    }

    .device-factor-wrapper {
      display: flex;

      > * {
        flex: 1;
        min: {
          width: 0;
          height: 0;
        }
      }
    }
  }

  .device-factor-wrapper {
    > .layout-content-wrapper {
      /deep/ {
        .layout-content-header {
          top: 0;
        }
      }
    }
  }

  .layout-content-wrapper {
    /deep/ {
      .layout-content-body {
        padding: {
          top: 0;
          right: 12px;
          bottom: 5px;
          left: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/03Device/index.vue